import { connect } from 'react-redux'
import { IStoreState, IZoneObject } from '../../types'
import StationUserTripsPane from '../../components/station-user-trips/StationUserTripsPane'
import { actionCreators } from '../../state/actions/trips'
import { clearMap, actionCreators as mapsActionCreators } from '../../state/actions/google_map'
import { IActiveTripResponseV2 } from '../../types/trip'
import { RouteComponentProps } from 'react-router-dom'
import { getAllGoinzones, getGoinzones, toggleZone } from '../../state/actions/goinzones'

export function mapStateToProps(state: IStoreState, ownProps: RouteComponentProps) {
  return {
    ...ownProps,
    currentUserId: state.user.currentUserId,
    currentOrganizationId: state.organizations.currentOrgId,
    showMembers: state.trips.settings.showMembers,
    tripFilters: state.trips.filters,
    zones: state.goinzones.items,
    visible: state.goinzones.visible
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    updateTrip: (trip: IActiveTripResponseV2) => dispatch(actionCreators.updateTripInState(trip)),
    clearMap: () => dispatch(clearMap()),
    getGoinzones: (orgId: string, serviceId: string) => {
      return dispatch(getGoinzones(orgId, serviceId))
    },
    getAllGoinzones: (orgId: string) => {
      return dispatch(getAllGoinzones(orgId))
    },
    toggleZone: (zone: { [key: string]: IZoneObject } | {}) => {
      return dispatch(toggleZone(zone))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StationUserTripsPane)



// WEBPACK FOOTER //
// ./src/containers/station-user-trips/StationUserTripsPane.ts